export default "__VITE_ASSET__B1rsg2me__"